import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const MakerCheckerRoutes: Routes = [
  {
    path: "maker-checker",
    loadComponent: () =>
      import("./maker-checker/maker-checker.component").then(
        (m) => m.MakerCheckerComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./maker-checker-list/maker-checker-list.component").then(
            (m) => m.MakerCheckerListComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./maker-checker-form/maker-checker-form.component").then(
            (m) => m.MakerCheckerFormComponent,
          ),
      },
    ],
  },
];
